import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user: {
            role: ''
        }
    },
    mutations: {
        login(state, user) {
            state.user = user;
        },
        logout(state) {
            state.user = {
                role: ''
            };
        }
    },
    actions: {
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                axios.post('/api/account/login', user)
                .then(res => {
                    commit('login', res.data);
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
            });
        },
        logout({commit}) {
            return axios.post('/api/account/logout')
            .then(() => {
                commit('logout');
            });
        }
    },
    getters: {
        isLoggedIn: (state) => state.user.role !== '',
        inRole: (state) => (roles) => {
            if (Array.isArray(roles)) {
                return roles.includes(state.user.role);
            } else {
                return state.user.role === roles;
            }
        },
        notInRole: (state, getters) => (roles) => !getters.inRole(roles)
    }
});

export default store;